module.exports = __webpack_public_path__ + "static/media/bragatoBg.6cebf9f6.jpg";